import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useI18n } from 'vue-i18n';
import useHttp from '@/utils/httpClient';
const http = useHttp();

export const useTranslationCache = defineStore('translationCache', () => {
  const translations = ref({});
  const labelsResponse = ref({});

  const { locale, setLocaleMessage, getLocaleMessage } = useI18n();
  const setTranslation = (data) => {
    translations.value[locale.value] = data;
    labelsResponse.value = data;
  };

  const currentTranslations = computed(() => {
    return translations.value[locale.value]
      ? translations.value[locale.value]
      : '';
  });

  // Action to fetch translations from the API or cache
  const fetchAndUpdateTranslations = async () => {
    if (!currentTranslations.value) {
      try {
        let response = await http.get('labels', {
          language: locale.value,
        });
        setTranslation(response.data);
      } catch (error) {
        console.error('Error fetching translations:', error);
      }
    } else {
      labelsResponse.value = currentTranslations.value;
    }

    setLocaleMessage(locale.value, {
      ...getLocaleMessage(locale.value),
      ...currentTranslations.value,
    });
  };

  return {
    fetchAndUpdateTranslations,
    labelsResponse,
  };
});
